import React, { useContext, useState } from "react";
import format from "lib/format";
import config from "lib/config";
import PropTypes from "prop-types";
import styled from "styled-components";
import LangContext from "../../../langContext";
import * as CONSTANTS from "domains/programs/constants";
import { getProgramProgress, navigateToMsTeams } from "../../../functions";
import { Button } from "Components/Base/Inputs/Button";
import Pie from "./Pie";
import dompurify from "dompurify";

const DESCRIPTION_LIMIT = 200;

const StyledProgramHeader = styled.div`
  margin: 0 0 10px 0;

  img {
    width: 100%;
    max-width: 900px;
    max-height: 150px;
    object-fit: cover;
  }

  .header-progress {
    min-width: 150px;
    max-width: 150px;
  }

  .header-info {
    padding: 10px;
  }
`;

const Header = (props) => {
  const sanitizer = dompurify.sanitize;
  const languageContext = useContext(LangContext);
  const [showMore, setShowMore] = useState(false);
  const { isPreview } = props;
  const {
    programId,
    title,
    activityTitle,
    description,
    longDescriptionForParticipants,
    descriptionFromProgramSession,
    responsible,
    registrationDate,
    image,
    microsoftTeamId,
    activityId,
  } = props.data;

  const descriptionToShow = descriptionFromProgramSession
    ? descriptionFromProgramSession
    : longDescriptionForParticipants;

  const displayShowMoreToggle =
    descriptionToShow && descriptionToShow.length > DESCRIPTION_LIMIT;

  const formatedDescriptionText =
    displayShowMoreToggle && !showMore
      ? descriptionToShow.substr(0, DESCRIPTION_LIMIT) + "..."
      : descriptionToShow;

  const dateFormat =
    config && config.shortDateFormat
      ? config.shortDateFormat.toUpperCase()
      : "yyyy-MM-dd HH:mm";
  const programProgressValue = getProgramProgress(props.data);
  const imageUrl = image
    ? format.url(
        `/utils/streamfile.aspx?type=courseobjectimage&param=${programId}/${encodeURIComponent(
          image,
        )}`,
      )
    : format.url(CONSTANTS.PROGRAM_IMAGE);

  return (
    <StyledProgramHeader>
      <div className="flex flex-space-b">
        <div className="flex-1">{<img src={imageUrl} alt={title} />}</div>
        <div
          className="header-progress flex align-c flex-center"
          id="programProgressPie"
        >
          <Pie progress={programProgressValue} />
        </div>
      </div>

      <div className="header-info column">
        <h2>{title}</h2>
        <h3>{activityTitle}</h3>
        {responsible && (
          <div>
            <strong>{languageContext("responsible1")}: </strong>
            <span>{responsible}</span>
          </div>
        )}
        <div>
          <strong>{languageContext("enrolled")}: </strong>
          {!isPreview && (
            <span>{moment(registrationDate).format(dateFormat)}</span>
          )}
        </div>
        {microsoftTeamId != "" && (
          <div className="flex">
            <Button
              onClick={() => navigateToMsTeams(activityId)}
              label={languageContext("toMSTeams")}
            />
          </div>
        )}
        {!displayShowMoreToggle && (
          <div
            className="flex-1"
            dangerouslySetInnerHTML={{
              __html: sanitizer(descriptionToShow),
            }}
          />
        )}
        {displayShowMoreToggle && (
          <>
            <div
              className="flex-1"
              dangerouslySetInnerHTML={{
                __html: sanitizer(formatedDescriptionText),
              }}
            />
            <br />
            <span
              className="pointer underline"
              onClick={() => setShowMore(!showMore)}
              tabIndex="0"
            >
              {showMore
                ? languageContext("showlessinfo")
                : languageContext("readmore")}
            </span>
          </>
        )}
      </div>
    </StyledProgramHeader>
  );
};

Header.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    activityTitle: PropTypes.string,
    responsible: PropTypes.string,
    registerdate: PropTypes.string,
    image: PropTypes.string,
  }),
};

Header.defaultProps = {
  activityTitle: "",
  responsible: "",
  registerdate: "",
  image: null,
};

export default Header;
